import React, { useContext, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useLocation, Link, useNavigate } from "react-router-dom";
import ApiHome from "../../../core/api/api.home";
import ContextApp from "./../../../core/contexts/context.app";

// import { AlertCircle } from 'feather-icons-react';
// import {RotateCircleLoading	} from "react-loadingg"
import _ from "lodash";
import CardTileSearch from "../../components/CardTileSearch";
import { IconErrorCircle, IconNotFound } from "../../../assets/icons";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SearchPage() {
  let location = useLocation();
  const ctx = useContext(ContextApp);
  const [searchList, setSearchList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm();
  useEffect(() => {
    (async () => {
      try {
        if (
          !_.isEmpty(location.state) &&
          !_.isEmpty(location.state.searchText)
        ) {
          let response = await ApiHome.getGlobalSearch(
            location.state.searchText
          );

          setIsLoading(false);

          if (response.succeeded == true) {
            setSearchList(response.data.amusementServiceS);
          } else {
          }
        } else {
          if (location.state.searchText == "") setIsLoading(false);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => {};
  }, [location]);
  const handleClick = (value) => {};
  const [searchText, setSearchText] = useState("");
  const handleSearch = (e) => {
    e.preventDefault();
    (async () => {
      let response = await ApiHome.getGlobalSearch(searchText);
      setIsLoading(false);
      if (response.succeeded == true) {
        setSearchList(response.data.amusementServiceS);
      }
      else {
        toast.error(response.message, {
          style: { marginTop: "55px" },
        });}
    })();
  };
  return (
    <Container fluid className="">
      {/* {isMobile ? null :
                <Row className="pt-5 text-small">
                    <Col xs={12} className="px-0">
                        <div className="text-line">
                            <span className="rounded-pill bg-white border  py-2 px-3">
                                <Link to="/" className="text-muted"> صفحه اصلی </Link>{" "} / {" "}
                                <Link to="/List" className="text-muted font-weight-bold"> دسته بندی تفریحات کیش </Link>
                            </span>
                        </div>
                    </Col>
                </Row>
            } */}

      <Container className="pt-4 py-lg-4 min-height-page">
        {isLoading ? (
          <>
            <div className="vh-100">
              <div className="text-center">در حال جستجو ...</div>

              <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </>
        ) : searchList?.length > 0 ? (
          <Row className={!isMobile ? "pt-3  gx-3" : " gx-0"}>
            {searchList?.map((itemData, index) => (
              <>
                <Col xs="12" sm="6" md="4" lg="3" className="mb-3">
                  <CardTileSearch
                    itemImgSrc={
                      process.env.REACT_APP_API_URL + itemData.imageUrl
                    }
                    amusementUrl={`/details/${itemData.urlName}`}
                    amusementName={itemData.name}
                    amusementPrice={itemData.price}
                    amusementFinalPrice={itemData.originalPrice}
                    handleClick={handleClick}
                  />
                </Col>
                {/* <ListItem
                  key={index}
                  itemTitle={itemData.name}
                  itemUrl={itemData.urlName}
                  itemImgSrc={itemData.imageUrl}
                  itemComment="12"
                  itemReserveDetails={_.attempt(
                    JSON.parse.bind(null, itemData.reserveDetails)
                  )}
                  // itemComment={itemData.itemComment}
                  // {...(itemData.amusementServiceOptionFields.length>0 ? {itemDiscount:itemData.amusementServiceOptionFields[0].discountPrice } : {})}
                  itemScore={itemData.totallyRankAverage}
                  // itemDiscount={itemData.discountPrice}
                  //itemDiscount={itemData.discount}
                  //itemDiscount={itemData.amusementServiceOptionFields.length>0 ? {itemDiscount:itemData.amusementServiceOptionFields[0].discountPrice} : 0 }
                  // itemPrice={itemData.amusementServiceOptionFields.length>0 ? {itemDiscount:itemData.amusementServiceOptionFields[0].price} : 0 }
                  itemPrice="0"
                  itemDiscount="0"
                /> */}
              </>
            ))}
          </Row>
        ) : (
          <>
            {isMobile ? (
              <Form onSubmit={handleSearch}>
                <Row className="border-bottom pb-3">
                  <Col>
                    <Form.Control
                      type="text"
                      autoFocus
                      placeholder="جستجو در تفریحان ..."
                      onChange={(e) => setSearchText(e.target.value)}
                    ></Form.Control>
                  </Col>
                  <Col xs="auto" className="ps-0">
                    <Button type="submit" className="btn btn-success">
                      جستجو
                    </Button>
                  </Col>
                </Row>
              </Form>
            ) : (
              ""
            )}

            <div className="text-center  xl-svg">
              <div className="full-width text-center px-3 mt-5">
                <IconNotFound fillColor="#b1b1b1" />
              </div>
              <Col className="pb-5 pt-5 text-center">
                <div className="fs-103  fw-bold">
                  {" "}
                  اطلاعاتی جهت نمایش یافت نشد !
                </div>
                <div className="mt-3 fs-101 text-black-06">
                  برای مشاهده لیست تفریحات از لینک زیر استفاده کنید.
                </div>
                <div className="text-center">
                  <>
                    <Link
                      to={
                        ctx.selectedCity?.englishName === undefined
                          ? "/c"
                          : `/c/${ctx.selectedCity?.englishName}`
                      }
                      className=" "
                    >
                      <Button variant="danger " className=" px-5  mb-5 mt-4 ">
                        <h3 className="fs-09 text-center mb-0 py-1 ">
                          مشاهده تمام تفریحات{" "}
                        </h3>
                      </Button>
                    </Link>
                  </>
                </div>
              </Col>
            </div>
          </>
        )}
      </Container>
    </Container>
  );
}
export default SearchPage;
